import { FC } from "react";
import { FormikProps } from "formik";
import { useTranslation } from "react-i18next";
import CustomRadioButton from "../../../custom-components/form-inputs/CustomRadioButton";
import { workCreationSecondStepFields } from "../../../validation-schemas/work-schemas/WorkCreationSchema";
import ExpiresInComponent from "./ExpiresInComponent";
import { WorkCreationSecondStep } from "../../../domain/models/dto/WorkDTO";

interface RadioButtonProps {
    form: FormikProps<WorkCreationSecondStep>;
}

const RadioButton: FC<RadioButtonProps> = (props) => {
    const { t } = useTranslation();

    return (
        <CustomRadioButton
            names={["showContactsForAll", "showContactsAfterSelect"]}
            form={props.form}
            fields={workCreationSecondStepFields}
            firstWrapClassName="flex dmax2:flex-col justify-between w-full dmin2:w-[1192px]"
            secondWrapClassName="flex flex-col"
            thirdWrapClassName="flex items-center"
            checkedRadioOuterClassName="min-w-8 dmax2:min-w-6 h-8 dmax2:h-6 rounded-full bg-transparent border-[2px] border-textWarning transition duration-300 mr-5 dmax2:mr-3"
            checkedRadioInnerClassName="bg-textWarning w-[14px] h-[14px]"
            uncheckedRadioClassName="min-w-8 dmax2:min-w-6 h-8 dmax2:h-6 bg-transparent border border-textFaded transition duration-300 mr-5 dmax2:mr-3"
            labelClassName="H20B dmax2:H16B text-textWhite w-full"
            extraContentArray={[
                <div key="work-creation-radioButton1" className="dmin2:w-[596px]">
                    <p className="H16 dmax2:H14 text-textFaded mt-5 dmax2:mt-3">
                        {t("workCreation.fields.radiobutton1Rule")}
                    </p>
                    <ExpiresInComponent form={props.form} disabled={!props.form.values.showContactsForAll} />
                </div>,
                <div key="work-creation-radioButton2">
                    <p className="H16 dmax2:H14 text-textFaded mt-5 dmax2:mt-3">
                        {t("workCreation.fields.radiobutton2Rule")}
                    </p>
                </div>,
            ]}
            extraHandlersArray={[
                null,
                () => {
                    props.form.setFieldValue("expiresInMinutes", null);
                },
            ]}
        />
    );
};

export default RadioButton;
